import { cn } from '@workspace/ui/lib/utils'

/**
 * Shared label + input wrapper with error state.
 *
 * - Renders a small muted label above the field.
 * - When `error` is set, shows the message in red below and paints a
 *   destructive ring on any nested `input` / `textarea`.
 *
 * Used by profile edit forms and analytics exclusion dialogs so that all
 * field validations across the app look and behave the same.
 */
export function FormField({
  label,
  children,
  className,
  error,
}: {
  label: string
  children: React.ReactNode
  className?: string
  error?: string | null
}) {
  return (
    <div
      className={cn(
        'space-y-1.5',
        error &&
          '[&_input]:ring-destructive/50 [&_input]:ring-[1.5px] [&_textarea]:ring-destructive/50 [&_textarea]:ring-[1.5px]',
        className
      )}
    >
      <span className="block text-xs font-medium text-muted-foreground">{label}</span>
      {children}
      {error && <p className="text-xs text-red-400">{error}</p>}
    </div>
  )
}
